import MComponent from '../../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import WithRouter from '../../Toolkit/WithRouter';
import React, {createRef, ReactElement, RefObject} from 'react';
import MPage, {MPageProps} from '../../Toolkit/Components/Shell/Page';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import MBackButton from '../../Toolkit/Components/Controls/BackButton';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import {DayView, DayViewMultiReply} from '../../Api/ControllerTypes/JobAssignmentTypes';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import {JobAssignmentClient} from '../../Api/JobAssignmentClient';
import MNSwagClientConfiguration from '../../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import MButton from '../../Toolkit/Components/Controls/Button';
import CalendarDialog from '../../Dialogs/CalendarDialog';
import {EnumerationClient} from '../../Api/EnumerationClient';
import {MOpenIconName, MSuccessIcon} from '../../Toolkit/Icons';
import {SendJobRequest, WorkMailClient} from '../../Api/WorkMailClient';
import {CrewContactData, WorkMailMultiReply} from '../../Api/ControllerTypes/WorkMailTypes';
import EmailConfirmDialog from '../../Dialogs/EmailConfirmDialog';
import MessageDialog from '../../Dialogs/MessageDialog';
import {CrewData} from '../../Api/ControllerTypes/CrewTypes';
import {Request} from '../../Api/ControllerTypes/RequestTypes';
import {Invoice} from '../../Api/ControllerTypes/InvoiceTypes';
import styles from './DayView.module.css';
import EnumContext from '../../Context/enum-context';
import MFormControl from '../../Toolkit/Components/Controls/FormControl';
import MDropDown from '../../Toolkit/Components/Controls/DropDown';
import {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import {MNullable} from '../../Toolkit/Utils';
import {ReactToPrint} from 'react-to-print';
import {Project, ProjectMultiReply} from '../../Api/ControllerTypes/ProjectTypes';
import {ProjectClient} from '../../Api/ProjectClient';
import TrafficManagementAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';

const itemsPerPrintPage = 6;

type Props = WithMsalProps & WithRouterProps & {};

type FilterData = {
    project: number;
    exchange: string;
    permitStatus: number;
    tmRequired: number;
    crew: number;
}

type State = {
    page: MPageProps;
    displayDate: Date;
    allData: DayView[];
    itemData: DayView[];
    selectedRow: DayView | undefined;
    exchanges: MDropDownItem<string>[] | undefined;
    permitStatuses: MDropDownItem<number>[] | undefined;
    tmTypes: MDropDownItem<number>[] | undefined;
    crews: MDropDownItem<number>[] | undefined;
    filterData: FilterData;
    projectList: Project[];
};

class DayViewPage extends MComponent<Props, State>{
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_dateSelectRef: RefObject<CalendarDialog>;
    private readonly m_projectRef: RefObject<MDropDown<number>>;
    private readonly m_exchangeRef: RefObject<MDropDown<string>>;
    private readonly m_permitRef: RefObject<MDropDown<number>>;
    private readonly m_tmRef: RefObject<MDropDown<number>>;
    private readonly m_crewRef: RefObject<MDropDown<number>>;
    private readonly m_emailConfirmRef: RefObject<EmailConfirmDialog>;
    private readonly m_messageDialogRef: RefObject<MessageDialog>;
    private readonly m_printAreaRef: RefObject<HTMLTableElement>;
    private readonly m_jobAssignClient: NSwagAdapter<JobAssignmentClient>;
    private readonly m_enumerationClient: NSwagAdapter<EnumerationClient>;
    private readonly m_workMailClient: NSwagAdapter<WorkMailClient>;
    private readonly m_projectClient: NSwagAdapter<ProjectClient>;

    public constructor(props: Props){
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_dateSelectRef = createRef<CalendarDialog>();
        this.m_projectRef = createRef<MDropDown<number>>();
        this.m_exchangeRef = createRef<MDropDown<string>>();
        this.m_permitRef = createRef<MDropDown<number>>();
        this.m_tmRef = createRef<MDropDown<number>>();
        this.m_crewRef = createRef<MDropDown<number>>();
        this.m_emailConfirmRef = createRef<EmailConfirmDialog>();
        this.m_messageDialogRef = createRef<MessageDialog>();
        this.m_printAreaRef = createRef<HTMLTableElement>();
        this.m_jobAssignClient = new NSwagAdapter<JobAssignmentClient>(new JobAssignmentClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_enumerationClient = new NSwagAdapter<EnumerationClient>(new EnumerationClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_workMailClient = new NSwagAdapter<WorkMailClient>(new WorkMailClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_projectClient = new NSwagAdapter<ProjectClient>(new ProjectClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));

        this.initializeState();
    }

    private bindMethods(): void{
        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
        this.projectTemplate = this.projectTemplate.bind(this);
        this.tmTypeTemplate = this.tmTypeTemplate.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.nextDay_Click = this.nextDay_Click.bind(this);
        this.previousDay_Click = this.previousDay_Click.bind(this);
        this.selectDay_Click = this.selectDay_Click.bind(this);
        this.onDateSelection = this.onDateSelection.bind(this);
        this.today_Click = this.today_Click.bind(this);
        this.open_Click = this.open_Click.bind(this);
        this.email_Click = this.email_Click.bind(this);
        this.sendMail = this.sendMail.bind(this);
        this.isEmailSendDisabled = this.isEmailSendDisabled.bind(this);
        this.project_OnSelect = this.project_OnSelect.bind(this);
        this.exchange_OnSelect = this.exchange_OnSelect.bind(this);
        this.permit_OnSelect = this.permit_OnSelect.bind(this);
        this.tm_OnSelect = this.tm_OnSelect.bind(this);
        this.crew_OnSelect = this.crew_OnSelect.bind(this);
        this.clearFilter_Click = this.clearFilter_Click.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {
            locked: false
        };

        const todayDate = new Date();
        todayDate.setHours(12,0,0);

        const filterData: FilterData = {
            project: -1,
            exchange: '',
            permitStatus: -1,
            tmRequired: -1,
            crew: -1
        }

        this.state = {
            page: page,
            displayDate: todayDate,
            selectedRow: undefined,
            allData: [],
            itemData: [],
            exchanges: undefined,
            permitStatuses: undefined,
            tmTypes: undefined,
            crews: undefined,
            filterData: filterData,
            projectList: []
        }
    }

    private async nextDay_Click() : Promise<void> {
        const newDay = this.state.displayDate!.getDate() + 1;
        const newDate = this.state.displayDate!;
        newDate.setDate(newDay);
        this.safeSetState(draft => draft.displayDate = newDate);
        await this.page_onLoadData(newDate);
    }

    private async previousDay_Click() : Promise<void> {
        const newDay = this.state.displayDate!.getDate() - 1;
        const newDate = this.state.displayDate!;
        newDate.setDate(newDay);
        this.safeSetState(draft => draft.displayDate = newDate);
        await this.page_onLoadData(newDate);
    }

    private selectDay_Click(): void {
        this.m_dateSelectRef.current?.show(this.state.displayDate);
    }

    private async onDateSelection(selectedDate: Date): Promise<void> {
        selectedDate.setHours(12,0,0);
        this.safeSetState(draft => draft.displayDate = selectedDate);
        await this.page_onLoadData(selectedDate);
    }

    private async today_Click(): Promise<void> {
        const todayDate = new Date();
        todayDate.setHours(12,0,0);
        this.safeSetState(draft => draft.displayDate = todayDate);
        await this.page_onLoadData(todayDate);
    }

    private project_OnSelect(newValue: MNullable<number>): void {
        this.safeSetState(draft => {
            draft.filterData.project = newValue ?? -1;
            draft.itemData = this.filterData(draft.filterData);
        });
    }

    private exchange_OnSelect(newValue: MNullable<string>): void {
        this.safeSetState(draft => {
            draft.filterData.exchange = newValue ?? '';
            draft.itemData = this.filterData(draft.filterData);
        });
    }

    private permit_OnSelect(newValue: MNullable<number>): void {
        this.safeSetState(draft => {
            draft.filterData.permitStatus = newValue ?? -1;
            draft.itemData = this.filterData(draft.filterData);
        });
    }

    private tm_OnSelect(newValue: MNullable<number>): void {
        this.safeSetState(draft => {
            draft.filterData.tmRequired = newValue ?? -1;
            draft.itemData = this.filterData(draft.filterData);
        });
    }

    private crew_OnSelect(newValue: MNullable<number>): void {
        this.safeSetState(draft => {
            draft.filterData.crew = newValue ?? -1;
            draft.itemData = this.filterData(draft.filterData);
        });
    }

    private filterData(filterData: FilterData) : DayView[] {
        let filteredData = this.state.allData;
        if(filterData.project !== -1) {
            filteredData = filteredData.filter(i => i.request?.projectValue === filterData.project);
        }
        if(filterData.exchange !== '') {
            filteredData = filteredData.filter(i => i.request?.exchange === filterData.exchange);
        }
        if(filterData.permitStatus !== -1) {
            filteredData = filteredData.filter(i => i.request?.permitStatus === filterData.permitStatus);
        }
        if(filterData.tmRequired !== -1) {
            filteredData = filteredData.filter(i => i.jobAssignment?.tmType.includes(filterData.tmRequired));
        }
        if(filterData.crew !== -1) {
            filteredData = filteredData.filter(i => ((i.crewData?.filter(c => c.crew.id === filterData.crew)?.length ?? 0) > 0));
        }

        return filteredData;
    }

    private clearFilter_Click(): void {
        this.m_projectRef.current!.setValue(-1);
        this.m_exchangeRef.current!.setValue(' ');
        this.m_permitRef.current!.setValue(-1);
        this.m_tmRef.current!.setValue(-1);
        this.m_crewRef.current!.setValue(-1);
        const filterData: FilterData = {
            project: -1,
            exchange: '',
            permitStatus: -1,
            tmRequired: -1,
            crew: -1
        }
        this.safeSetState(draft => {
            draft.filterData = filterData;
            draft.itemData = draft.allData;
        });
    }

    private open_Click(id: string): void {
        this.props.navigate(`/bookings/${id}`);
    }

    private async email_Click(): Promise<void> {
        const crewReply = await this.m_workMailClient.callWithReply(
            WorkMailMultiReply, client => client.listAssignedCrews(this.state.displayDate));
        crewReply.throwIfFailed();

        const userName = this.props.msalContext.accounts[0].username;

        const emailAddresses: string[] = [];
        if(crewReply.reply!.crews.length > 0) {
            for(let crew of crewReply.reply!.crews) {
                if(crew.crewContacts.length === 0) {
                    //no email contacts for crew so send to logged in user.
                    emailAddresses.push(userName);
                } else {
                    emailAddresses.push(...crew.crewContacts.map(cc => cc.contact))
                }
            }
        } else {
            //No crews assigned so send to logged in user.
            emailAddresses.push(userName);
        }
        const uniqueAddresses = emailAddresses.filter((item, i, ar) => ar.indexOf(item) === i);

        //Pop up to confirm send.
        this.m_emailConfirmRef.current!.show(crewReply.reply!.crews, uniqueAddresses, this.sendMail, true);
    }

    private async sendMail(crewContactData: CrewContactData[], emailAddresses: string[]): Promise<void> {
        const userName = this.props.msalContext.accounts[0].username;

        for(let ccd of crewContactData) {
            let emails: string[] = [];
            if(ccd.crewContacts.length === 0) {
                //no email contacts for crew so send to logged in user.
                emails = [userName];
            } else {
                emails = ccd.crewContacts.filter(cc => emailAddresses.includes(cc.contact)).map(cc => cc.contact);
            }
            const crewReply = await this.m_workMailClient.call(
                client => client.sendJobsForCrew(new SendJobRequest({
                    workDate: this.state.displayDate,
                    crewId: ccd.crew.id,
                    recipients: emails
                })));
            crewReply.throwIfFailed();
        }

        this.m_messageDialogRef.current!.show(
            'Send Complete',
            `Email send complete`,
            MSuccessIcon);
    }

    private table_onSelectionChange(selection: DayView | DayView[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as DayView | undefined);

    }

    private isEmailSendDisabled(): boolean {
        const allowedRoles: string[] = ['Booking', 'Supervisor'];
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const access = allowedRoles.some(a => roles?.includes(a));

        return !access
            || this.state.itemData.length === 0;
    }

    private async page_onLoadData(viewDate: Date | undefined = undefined): Promise<void> {
        const queryDate = viewDate === undefined ? this.state.displayDate : viewDate;

        const dayViewResult = await this.m_jobAssignClient.callWithReply(
            DayViewMultiReply, (client => client.getDayView(queryDate!)));
        dayViewResult.throwIfFailed();

        //let projects = dayViewResult.reply!.jobAssignments.map(ja => ja.request?.projectValue);
        //projects = projects.filter((value, index, array) => array.indexOf(value) === index);
        let exchanges = dayViewResult.reply!.jobAssignments.map(ja => ja.request?.exchange);
        exchanges = exchanges.filter((value, index, array) => array.indexOf(value) === index);
        let permitStatuses = dayViewResult.reply!.jobAssignments.map(ja => ja.request?.permitStatus);
        permitStatuses = permitStatuses.filter((value, index, array) => array.indexOf(value) === index);
        let tmTypes: number[] = [];
        dayViewResult.reply!.jobAssignments.forEach(ja => ja.jobAssignment?.tmType.forEach(jt => tmTypes.push(jt)));
        tmTypes = tmTypes.filter((value, index, array) => array.indexOf(value) === index);
        let crews: CrewData[] = [];
        dayViewResult.reply!.jobAssignments.forEach(ja => ja.crewData?.forEach(c => crews.push(c)));
        crews = crews.filter((value, index, array) => array.findIndex(c => c.crew.id === value.crew.id) === index);

        const projectResult = await this.m_projectClient.callWithReply(ProjectMultiReply, (client) => client.getAll());
        projectResult.throwIfFailed();

        //Save data to state.
        this.safeSetState((draft) => {
            draft.allData = dayViewResult.reply!.jobAssignments;
            draft.itemData = dayViewResult.reply!.jobAssignments;
            draft.exchanges = exchanges.map(e => { return { label: e ?? '', value: e ?? ''}});
            draft.permitStatuses = permitStatuses.map(p => {
                const index = this.context?.enums?.permitStatuses?.findIndex(perm => perm.id === p)
                return { label: (this.context?.enums?.permitStatuses[index ?? -1]?.name ?? ''), value: p! };
            });
            draft.tmTypes = tmTypes.map(t => {
                const index = this.context?.enums?.jobTypes?.findIndex(jobType => jobType.id === t)
                return { label: (this.context?.enums?.jobTypes[index ?? -1]?.name ?? ''), value: t! };
            });
            draft.crews = crews.map(c => { return { label: c.crew.crewName, value: c.crew.id} });
            draft.projectList = projectResult.reply!.projects;
        })
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {

        return (
            <MToolbar>
                <MBackButton disabled={false}/>
                <MSpacer/>
                <MButton label="Previous Day"
                         icon={"pi pi-caret-left"}
                         iconOnly={false}
                         disabled={false}
                         onClick={this.previousDay_Click}/>
                <MSpacer/>
                <MButton label="Next Day"
                         icon="pi pi-caret-right"
                         iconOnly={false}
                         disabled={false}
                         onClick={this.nextDay_Click}/>
                <MSpacer/>
                <MButton label="Select Date"
                         icon="pi pi-calendar"
                         iconOnly={false}
                         disabled={false}
                         onClick={this.selectDay_Click}/>
                <MSpacer/>
                <MButton label="Today"
                         color="info"
                         icon="pi pi-calendar-times"
                         iconOnly={false}
                         disabled={false}
                         onClick={this.today_Click}/>
                <MSpacer/>
                <MButton label="Send Work Mails"
                         color="warning"
                         icon={"pi pi-send"}
                         iconOnly={false}
                         disabled={this.isEmailSendDisabled}
                         onClick={this.email_Click}
                />
                <MSpacer/>
                <ReactToPrint trigger={() => <MButton label={'Print'}
                                                      color={'success'}
                                                      icon={'pi pi-print'}
                                                      disabled={false} />}
                              content={() => this.m_printAreaRef.current}
                />
            </MToolbar>
        );
    }

    private projectTemplate(requestData: Request) {
        const index = this.state.projectList.findIndex(value => value.id === requestData.projectValue);

        if(index === undefined || index === -1) {
            return null;
        }

        return this.state.projectList[index!].name;
    }

    private requestDateTemplate(requestData: Request) {
        if(requestData.createdOn != null) {
            try {
                return requestData.createdOn.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private jobDateTemplate(requestData: Request) {
        if(requestData.endType === 0) {
            if(requestData.jobStartDate != null && requestData.jobEndDate != null) {
                try {
                    return (<span style={{fontSize: 'small'}}>
                    {requestData.jobStartDate.toLocaleDateString() + ' - '} <br/>
                        {requestData.jobEndDate.toLocaleDateString()}
                </span>);
                } catch {
                    return '';
                }
            }
            return '';
        }

        return 'In Situ';
    };

    private dayTemplate(requestData: Request):ReactElement {
        const selectedDays = requestData.selectedDays;
        const dayArray: string[] = [];

        selectedDays.forEach(d => {
            const dayName = d.toLocaleDateString('en-GB', { weekday: 'short' });
            if(!dayArray.includes(dayName)) {
                dayArray.push(dayName);
            }
        });

        return <span style={{fontSize: 'small', whiteSpace: 'normal'}}>
            {dayArray.join(', ')}
        </span>;
    }

    private timeTemplate(requestData: Request):ReactElement {
        const startTime = requestData.jobStartDate?.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'});
        const endTime = requestData.jobEndDate?.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'});

        if(requestData.endType === 0){
            return <span>
                {`${startTime} - ${endTime}`}
            </span>;
        }
        return <span>
            In Situ
        </span>
    }

    private estimateTemplate(requestData: DayView, printing: boolean): ReactElement | undefined {
        const tmTypes = this.state.itemData.filter(r => r.request!.id === requestData.request!.id);
        const firstTmType = tmTypes[0].jobAssignment.tmType[0]

        if(printing){
            return <td className={styles.data}>{requestData.request?.estimate}</td>;
        }

        if(requestData.jobAssignment.tmType[0] === firstTmType)
        {
            return <td colSpan={tmTypes.length} className={styles.data}>{requestData.request?.estimate}</td>;
        }

        return undefined;

    }

    private locationTemplate(requestData: Request) {
        return <span style={{fontSize: 'xx-small'}}>
            <div>{requestData.address1}</div>
            {requestData.address2 !== undefined && <div>{requestData.address2}</div>}
            {requestData.address3 !== undefined && <div>{requestData.address3}</div>}
            <div>{requestData.city}, {requestData.county}</div>
            <div>{requestData.postcode}</div>
        </span>;
    }

    private tmTypeTemplate(requestData: DayView): string {

        const returnData = requestData.jobAssignment!.tmType.map((jt) => {
                const index = this.context.enums?.jobTypes.findIndex(value => value.id === jt);
                return index === undefined && index === -1
                    ? ''
                    : this.context.enums?.jobTypes[index!].name ?? '';
            }
        )

        return returnData.join(', ');
    }

    private crewTemplate(crews: CrewData[]) {
        return <span style={{fontSize: 'small', whiteSpace: 'normal'}}>
            {crews.map(c => c.crew.crewName).join(', ')}
        </span>;
    }

    private civilTemplate(requestData: Request) {
        return <span style={{fontSize: 'small'}}>
            <div>{requestData.civilsName}</div>
            <div>{requestData.civilsEmail}</div>
            <div>{requestData.civilsPhone}</div>
        </span>;
    }

    private permitTemplate(requestData: Request): ReactElement
    {
        return <div>{requestData.permitRef}</div>;
    }

    private invoiceTemplate(invoices: Invoice[]): ReactElement
    {
        return <span style={{fontSize: 'small', whiteSpace: 'normal'}}>
            {invoices.map(i => i.poNumber).join('\n')}
        </span>;
    }

    public render(): ReactElement {

        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        const dateString = `${dayNames[this.state.displayDate!.getDay()]}, ${this.state.displayDate!.toLocaleDateString()}`
        const titleText = `Day View - ${dateString}`;

        return (
            <MPage title={titleText}
                   locked={this.state.page.locked}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}
                   ref={this.m_pageRef}            >

                <CalendarDialog onDateSelected={this.onDateSelection}
                                ref={this.m_dateSelectRef}
                />
                <EmailConfirmDialog ref={this.m_emailConfirmRef}/>
                <MessageDialog ref={this.m_messageDialogRef}/>

                {/*This area is just used for the print*/}
                <div style={{ display: "none"}}>
                    <div ref={this.m_printAreaRef} className={styles.printArea}>
                        <style>
                            {`@media print {@page { size: landscape;}}`}
                        </style>
                        {this.RenderPages(dateString)}
                    </div>
                </div>

                {/*This area is the screen display*/}
                <div className={styles.pageLeft}>
                    <div className={styles.parent}>
                        {this.RenderTable(true, -1, 0)}
                    </div>
                </div>

                <div className={styles.pageRight}>
                    <div className="formgrid grid">
                        <div className="col-12 md:col-12">
                            <MFormControl label={'Project'} id={'projectFilter'}>
                                {(fieldClasses: string | undefined) => {
                                    return (
                                        <MDropDown id={'projectValue'}
                                                   ref={this.m_projectRef}
                                                   disabled={false}
                                                   items={this.state.projectList.map(project => ({
                                                       value: project.id,
                                                       label: project.code + ' - ' + project.name
                                                   }))}
                                                   initialValue={0}
                                                   onChange={this.project_OnSelect}
                                        />
                                    );
                                }}
                            </MFormControl>
                        </div>

                        <div className="col-12 md:col-12">
                            <MFormControl label={'Exchange'} id={'exchangeFilter'}>
                                {(fieldClasses: string | undefined) => {
                                    return (
                                        <MDropDown id={'exchangeValue'}
                                                   ref={this.m_exchangeRef}
                                                   disabled={false}
                                                   items={this.state.exchanges ?? []}
                                                   initialValue={' '}
                                                   onChange={this.exchange_OnSelect}
                                        />
                                    );
                                }}
                            </MFormControl>
                        </div>

                        <div className="col-12 md:col-12">
                            <MFormControl label={'Permit Status'} id={'permitStatusFilter'}>
                                {(fieldClasses: string | undefined) => {
                                    return (
                                        <MDropDown id={'permitStatusValue'}
                                                   ref={this.m_permitRef}
                                                   disabled={false}
                                                   items={this.state.permitStatuses ?? []}
                                                   initialValue={-1}
                                                   onChange={this.permit_OnSelect}
                                        />
                                    );
                                }}
                            </MFormControl>
                        </div>

                        <div className="col-12 md:col-12">
                            <MFormControl label={'TM Required'} id={'tmRequiredFilter'}>
                                {(fieldClasses: string | undefined) => {
                                    return (
                                        <MDropDown id={'tmRequiredValue'}
                                                   ref={this.m_tmRef}
                                                   disabled={false}
                                                   items={this.state.tmTypes ?? []}
                                                   initialValue={-1}
                                                   onChange={this.tm_OnSelect}
                                        />
                                    );
                                }}
                            </MFormControl>
                        </div>

                        <div className="col-12 md:col-12">
                            <MFormControl label={'Crew'} id={'crewFilter'}>
                                {(fieldClasses: string | undefined) => {
                                    return (
                                        <MDropDown id={'crewValue'}
                                                   ref={this.m_crewRef}
                                                   disabled={false}
                                                   items={this.state.crews ?? []}
                                                   onChange={this.crew_OnSelect}
                                        />
                                    );
                                }}
                            </MFormControl>
                        </div>

                        <div className="col-12 md:col-12">
                            <MButton label="Clear Filter"
                                     disabled={false}
                                     onClick={this.clearFilter_Click}
                            />
                        </div>
                    </div>
                </div>
            </MPage>
        )
    }

    private RenderPages(dateString: string): ReactElement {
        let startIndex: number = 0;
        let pageArray: ReactElement[] = [];

        while (startIndex < this.state.itemData.length){
            pageArray.push(
                <div className={styles.printPage}>
                    <div className={styles.printTitle}>
                        {dateString}
                    </div>
                    {this.RenderTable(false, startIndex, startIndex + itemsPerPrintPage)}
                </div>
            );

            startIndex += itemsPerPrintPage;
        }

        return (<React.Fragment>
            {pageArray}
            </React.Fragment>);
    }

    private RenderTable(showbuttons: boolean, startIndex: number, count: number): ReactElement {

        const printData = startIndex === -1 ? this.state.itemData : this.state.itemData.slice(startIndex, count + startIndex);
        const indexShift = startIndex === -1 ? 1 : startIndex + 1;

        return (
        <table className={styles.table}>
            <thead>
            <tr>
                <th className={styles.header}>TM Crew</th>
                {printData.map((r, index) =>
                    <th className={styles.header}>{index + indexShift}</th>
                )}
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className={styles.dataTitle}>Project Code</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.projectTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Exchange</td>
                {printData.map(r =>
                    <td className={styles.data}>{r.request?.exchange}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Requested By</td>
                {printData.map(r =>
                    <td className={styles.data}>{r.request?.requestor}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Created Date</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.requestDateTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Job Dates</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.jobDateTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Job Times</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.timeTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Estimate</td>
                {printData.map(r =>
                    this.estimateTemplate(r, !showbuttons)
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Permit</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.permitTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>PO Numbers</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.invoiceTemplate(r.invoice!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Location</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.locationTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>TM Required</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.tmTypeTemplate(r)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Day Only</td>
                {printData.map(r =>
                    <td className={styles.data}>{r.request?.dayOnly ? 'Yes': 'No'}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Crew(s)</td>
                {printData.map(r =>
                    <td className={styles.crewText}
                        style={(r.crewData?.length ?? 0) > 0 ? {background: "#" + r.crewData![0].crew.highlightColour} : {background: "#d32f2f"}}>
                        {(r.crewData?.length ?? 0) > 0 ? this.crewTemplate(r.crewData!) : 'Not assigned to crew'}
                    </td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Civil</td>
                {printData.map(r =>
                    <td className={styles.data}>{this.civilTemplate(r.request!)}</td>
                )}
            </tr>

            <tr>
                <td className={styles.dataTitle}>Site Docs</td>
                {printData.map(r =>
                    <td className={styles.data}>{r.request?.siteDocsComplete ? 'Yes': 'No'}</td>
                )}
            </tr>

            {showbuttons && <tr>
                <td className={styles.button}></td>
                {printData.map(r =>
                    <td className={styles.button}>{
                        <MButton label="Open"
                                 color="primary"
                                 icon={MOpenIconName}
                                 iconOnly={false}
                                 disabled={false}
                                 onClick={this.open_Click.bind(this, r.request?.id!)}
                        />}
                    </td>
                )}
            </tr>}
            </tbody>
        </table>);
    }
}

export default withMsal(WithRouter(DayViewPage));
